module.exports = __webpack_public_path__ + "static/img/theme-img2.a231f49e.jpg";